import { toCamelCase } from "components/collections/util/format";

const ColumnCallbaks = ({
  _columns,
  _rows,
  isReadOnly,
  setColumns,
  setRows,
  setSelectedCell,
  pushColumnOperation
}) => {

  const _onClickAddColumn = (type) => {

    if(isReadOnly) return;

    const column = { type, name: `column${_columns.length}`, label: `Column ${_columns.length}` };
    const newColumns = [..._columns, column];

    setColumns(newColumns);
    pushColumnOperation([
      ..._columns.map(col => ({
        initial: col,
        final: col,
        internal: col.internal,
        action: 'none'
      })),
      {
        initial: null,
        final: column,
        action: 'create'
      }
    ]);
    setSelectedCell({ row: -1, column: _columns.length });

  }

  const _onClickChangeColumn = (index, column) => {

    if (isReadOnly) return;
    if (!_columns[parseInt(index)] || !column) return;

    let newColumns = Object.assign([], _columns);
    newColumns = newColumns.map(col => Object.assign({}, col));
    newColumns[parseInt(index)] = column;

    setColumns(newColumns);
    pushColumnOperation(_columns.map((col, i) => ({
      initial: col,
      final: i == index ? column : col,
      internal: col.internal,
      action: i == index ? 'update' : 'none'
    })));

  }

  const _onClickMoveLeftColumn = (index) => {
    
    if (isReadOnly || index <= 0) return;

    let newColumns = [..._columns];
    newColumns = newColumns.map(col => Object.assign({}, col));

    const temp = newColumns[index - 1];
    newColumns[index - 1] = newColumns[index];
    newColumns[index] = temp;

    setColumns(newColumns);
    pushColumnOperation(newColumns.map((col, i) => ({
      initial: col,
      final: col,
      internal: col.internal,
      action: 'none'
    })));

  }

  const _onClickMoveRightColumn = (index) => {
    
    if (isReadOnly || index >= _columns.length - 1) return;

    let newColumns = [..._columns];
    newColumns = newColumns.map(col => Object.assign({}, col));

    const temp = newColumns[index + 1];
    newColumns[index + 1] = newColumns[index];
    newColumns[index] = temp;

    setColumns(newColumns);
    pushColumnOperation(newColumns.map((col, i) => ({
      initial: col,
      final: col,
      internal: col.internal,
      action: 'none'
    })));

  }

  const _onClickDeleteColumn = (index) => {

    if (isReadOnly) return;

    const column = _columns[parseInt(index)];

    let newColumns = [..._columns];
    newColumns = newColumns.map(col => Object.assign({}, col));
    newColumns.splice(index, 1);

    let newRows = [..._rows];
    newRows = newRows.map(row => Object.assign({}, row));
    newRows.forEach(row => {
      row.data = { ...row.data };
      delete row.data[column.name];
    });

    setColumns(newColumns);
    setRows(newRows);
    pushColumnOperation(_columns.map((col, i) => ({
      initial: col,
      final: col,
      internal: col.internal,
      action: i == index ? 'delete' : 'none'
    })));

  }

  return {
    _onClickAddColumn,
    _onClickChangeColumn,
    _onClickMoveLeftColumn,
    _onClickMoveRightColumn,
    _onClickDeleteColumn
  }

}

export default ColumnCallbaks;